/* @flow */
import { observable } from 'mobx';

import { ApiModel } from 'api/ApiModel';
import type { Brand } from 'models/Brands';

export default class BrandStore extends ApiModel {
  @observable selectedBrand: Brand | void;
  @observable brandLoading = false;

  loadBrand = async (brandId: string) => {
    this.brandLoading = true;
    this.selectedBrand = undefined;
    const brand = await this.api.getResource(`brands/${brandId}`);
    if (brand) {
      this.selectedBrand = brand;
    }

    this.brandLoading = false;
    return brand;
  };
}
